<template>
    <div class="has-text-centered">
        <p class="m-b-1" v-if="!isValid"><small>{{ i18n.nevyplnili_ste_vsetky_povinne_polia }}</small></p>
        <template v-if="!loading">
            <button type="button" class="button button-orange" @click="order">
                {{ i18n.dokoncit_objednavku }}
            </button>
            <br>
            <small>{{ i18n.s_povinnostou_platby }}</small>
        </template>
        <button type="button" class="button button-green button--no-action" v-else>
            {{ i18n.prebieha_spracovanie }} &nbsp; <span class="material-icons rotating">hourglass_bottom</span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "CheckoutButton",
        data: function () {
            return {
                loading: false,
                isValid: true,
                i18n: i18n
            }
        },
        methods: {
            order: function () {
                if (!this.loading) {
                    this.loading = true;
                    let form = document.getElementById('checkout-form');
                    this.isValid = form.checkValidity();
                    if (this.isValid) {
                        form.submit();
                    } else {
                        this.loading = false;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
